<template>
    <div>
        <button-white @click="showModal = true">
            Bearbeiten
        </button-white>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    Berechtigungen bearbeiten
                </template>
                <permission-edit v-model="local"></permission-edit>
            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from "../Modal";
import ButtonWhite from "./ButtonWhite";
import PermissionEdit from "../PermissionEdit";

export default {
    name: "PermissionEditDialog",

    components: {PermissionEdit, ButtonWhite, Modal},

    props: ['value'],

    data: () => ({
        showModal: false,
    }),

    computed: {
        local: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
}
</script>

<style scoped>

</style>
